<template>
  <div id="app">
    <Header />
    <Nav />
    <router-view :key="key" />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { get } from "./utils/localStorage.js";
import { getMemberLike, wxLogin } from './api';
import { mapMutations } from 'vuex';
import { wait }  from '@/utils/tools.js'

export default {
  data() {
    return {};
  },
  async created(){
    console.log('app created');
    const userInfo = get('userInfo');

    // 微信登入拿到的code
    const url = new URL(location.href);
    const wzCode = url.searchParams.get('code');
    console.log('wzCode',wzCode);
    if(wzCode) {
      console.log('執行微信登入');
      const res = await wxLogin({ credential: wzCode });
      if(res.status=='ok') {
        console.log('ok');
      }else{
        console.log('no ok');
      }
    }


    console.log('userInfo',userInfo);
    if(userInfo) {
      try {
        this.$store.commit('SET_USER_INFO',userInfo);

        await wait();
        // 取得我的最爱清单
        const { product } = await getMemberLike({ count:10000,pages:1 });
        console.log('product',product);
        const favoriteProductNo = product.map(item => {
          return item.id;
        })
        this.SET_PRODUCT_FAVORITE(favoriteProductNo); 
      } catch (error) {
        console.log(error);
        console.log('未登入拿不到關注清單');
      }
    }
  },
  mounted() {},
  methods: {
    ...mapMutations(['SET_PRODUCT_FAVORITE'])
  },
  computed: {
    key() {
      return this.$route.name !== undefined
        ? this.$route.name + new Date()
        : this.$route + new Date();
    },
  },

  components: {
    Nav,
    Footer,
    Header,
  },
};
</script>

<style lang='less'>
body {
  @media (max-width: 992px) {
    padding-top: 46px
  }
}
// 修正elementUI的dialog跑版
.el-message-box {
  @media (max-width:440px) {
    width: 90% !important;
  }
}
</style>
